import React from 'react';
import Navbar from './component/Navbar'
import Intro from './component/intro'
import Second from './component/second'
import Skills from './component/skills'
import Project from './component/project';
import Education from './component/edudncerti';
import Resume from './component/resume';
import Footer from './component/footer';
// import Mainpage from './mobile device/mainpage';

function Home() {
//   if(window.innerWidth<=450)
// {
//   return (
//     <>
//    <Mainpage/>
   
//     </>
//   )

// }else{
//   return (
//     <>
//    <Navbar/>
//    <Intro/>
//    <Second/>   
//   <Skills/>
//   <Project/>
//   <Education/>
//   <Resume/>
//   <Footer/>
//     </>
//   )
// }]
return (
      <>
    <Navbar/>
    <Intro/>
    <Second/>   
   <Skills/>
   <Project/>
   <Education/>
   <Resume/>
   <Footer/>
     </>
   )
 
  
 
}

export default Home